import { Card, CardContent, CardHeader, Skeleton } from "@mui/material";

interface Props {
    height: string
}

const LoadingDashlet = (props: Props) => {
    return (
        <Card
            sx={{
                height: props.height
            }}
        >
            <CardHeader
                title={<Skeleton animation="wave" height={'1.5rem'} width="40%" /> }
            />
            <CardContent
                sx={{
                    height: 'calc(100% - 64px)',
                    pb: '0px',
                    pt: '8px'
                }}
            >
                <Skeleton animation="wave" height={'100%'}/>
            </CardContent>
        </Card>
    )
}

export default LoadingDashlet;